module.exports = __webpack_public_path__ + "img/auth8.c2cb91fc.png";